import {AUTHENTICATION_CONSTANTS} from "../constants/authentication-constants";
import axios from "../services/axios";
import arrayHelper from "../helpers/array-helper";

const AuthenticationStates = {
    authenticated: false,
    user: {},
    lastChatLanguage: '',
    token: null,
    wallets: [],
    currencyList: [
        {
            code: 'BTC',
            currency: 'BTC',
            name: 'Bitcoin',
        }
    ],
    currencies: [],
    ignores: [],
    activeStreamID: null,
    networkSettings: [],
    selectedWallet: null,
    activeWallet: 'BTC',
    activeNetwork: 'BTC',
    hideZeroBalances: false,
    displayCryptoInFiat: false,
    selectedFiat: null,
    navigateHome: null,
    fiatRates: {},
};

const authenticationReducer = (state = AuthenticationStates, action) => {
    switch (action.type) {

        case AUTHENTICATION_CONSTANTS.SET_FIAT_RATES:
            return {
                ...state,
                fiatRates: action.data
            }

        case 'UPDATE_SHARED_STATE':
            console.log('UPDATE_SHARED_STATE = ', action)
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };

        case AUTHENTICATION_CONSTANTS.SET_LAST_CHAT_LANGUAGE:
            return {
                ...state,
                lastChatLanguage: action.data
            }
        case AUTHENTICATION_CONSTANTS.SET_HIDE_ZERO_BALANCE:
            localStorage.setItem('hideZeroBalances', action.data)
            return {
                ...state,
                hideZeroBalances: action.data
            }

        case AUTHENTICATION_CONSTANTS.SET_SELECTED_FIAT:
            localStorage.setItem('selectedFiat', action.data)
            return {
                ...state,
                selectedFiat: action.data,
                displayCryptoInFiat: !!action.data
            }

        case AUTHENTICATION_CONSTANTS.SET_DISPLAY_FIAT_IN_CRYPTO:
            if (!action.data)
                localStorage.removeItem('selectedFiat')

            return {
                ...state,
                displayCryptoInFiat: action.data,
                // selectedFiat: action?.data ? state.selectedFiat : null
            }


        case AUTHENTICATION_CONSTANTS.SET_USER_TOKEN:

            // console.log(AUTHENTICATION_CONSTANTS.SET_USER_TOKEN, action.data)

            // if (action?.data?.ws) {
            //     try {
            //         const wsApiToken = decrypt(action?.data?.ws)
            //         console.log(wsApiToken?.accessToken)
            //         if (wsApiToken?.accessToken)
            //             axios.setHeader('token', wsApiToken?.accessToken)
            //
            //     } catch (e) {
            //         console.error(e)
            //     }
            // }

            localStorage.setItem('bearer', action.data?.token)
            axios.setHeader('Authorization', `Bearer ${action.data?.token}`)
            return {
                ...state,
                user: {
                    ...state.user,
                    authenticated: true,
                    website_id: action?.data?.w_id,
                    ref_code: action?.data?.ref_code,
                    username: action?.data?.username,
                    is_streamer: action?.data?.is_streamer || false,
                    rank: action?.data?.rank,
                    authenticator_enabled: action?.data?.authenticator_enabled,
                    id: action?.data?.id,
                    ws: action?.data?.ws,
                    percentage: action?.data?.percentage,
                    email: action?.data?.email,
                    registration: action?.data?.registration,
                    email_verified_at: action?.data?.email_verified_at,
                    phone_verified_at: action?.data?.phone_verified_at
                },
                token: action?.data?.token,
                authenticated: true

            }

        case AUTHENTICATION_CONSTANTS.NAVIGATE_TO_HOMEPAGE:
            return {
                ...state,
                navigateHome: action.data
            }
        case AUTHENTICATION_CONSTANTS.SET_WALLET_PERCENTAGE:
            return {
                ...state,
                user: {
                    ...state.user,
                    percentage: action.data,
                },
            }

        case AUTHENTICATION_CONSTANTS.SET_IGNORED_USERS:
            return {
                ...state,
                ignores: action.data
            }

        case AUTHENTICATION_CONSTANTS.SET_STREAM_ID:
            return {
                ...state,
                activeStreamID: action.data
            }
        case AUTHENTICATION_CONSTANTS.SET_CURRENCIES:
            return {
                ...state,
                currencies: action.data
            }
        case AUTHENTICATION_CONSTANTS.SET_USER_TOKEN_LOCAL:
            // console.log('AUTHENTICATION_CONSTANTS.SET_USER_TOKEN_LOCAL = ', action.data)
            localStorage.setItem('bearer', action.data)
            axios.setHeader('Authorization', `Bearer ${action.data}`)
            return {
                ...state,
                user: {
                    ...state.user,
                    username: action?.data?.username
                },
                token: action?.data?.token,
                authenticated: true

            }

        case AUTHENTICATION_CONSTANTS.SET_WALLET_BALANCE:
            // todo balance update emit !!!
            // console.log(action.data)
            // console.log(state.wallets)
            const newWallets = state.wallets.map(i => i.id === action.data.id ? {
                ...i,
                balance: action.data.balance
            } : i)
            const updateList = arrayHelper.groupBySumWallets(newWallets)

            return {
                ...state,
                wallets: newWallets,
                currencyList: updateList,
                selectedWallet: state.selectedWallet ? updateList.find(i => i.code === state.selectedWallet.code) : updateList[0]
            }


        case AUTHENTICATION_CONSTANTS.SET_USER_LOGOUT:
            localStorage.removeItem('bearer')
            axios.setHeader('Authorization', null)
            return {
                ...state,
                user: {},
                token: null,
                authenticated: false

            }
        case AUTHENTICATION_CONSTANTS.SET_NETWORK_SETTINGS:
            return {
                ...state,
                networkSettings: action.data
            }
        case AUTHENTICATION_CONSTANTS.SET_USER_WALLETS:
            // console.log(AUTHENTICATION_CONSTANTS.SET_USER_WALLETS,action?.data)
            // console.log('state.selectedWallet = ',state.selectedWallet)

            const wholeList = arrayHelper.groupBySumWallets(action.data)

            const selected1 = state.selectedWallet ? wholeList.find(i => i.code === state.selectedWallet.code) : wholeList[0]

            // console.log(AUTHENTICATION_CONSTANTS.SET_USER_WALLETS, action.data)

            // console.log()


            // console.log('wholeList = ', wholeList)

            return {
                ...state,
                wallets: action?.data,
                selectedWallet: selected1,
                currencyList: wholeList
            }


        case AUTHENTICATION_CONSTANTS.SET_ACTIVE_WALLET:
            return {
                ...state,
                selectedWallet: action?.data,
                activeWallet: action?.data?.code,
                activeNetwork: action?.data?.network?.name,
            }

        case AUTHENTICATION_CONSTANTS.SET_ACTIVE_NETWORK:
            return {
                ...state,
                activeNetwork: action?.data
            }
        default:
            return state;

    }
};

export default authenticationReducer;
